import React from 'react'

import { IconComponent } from '@application/Interfaces/Icons/types'

export const RedCrossIcon: IconComponent = ({ className, width = 100, height = 100 }) => {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="50" cy="50" r="50" fill="white" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M67.6781 63.25C68.8999 64.4687 68.8999 66.4689 67.6781 67.6876C66.4593 68.9064 64.4781 68.9064 63.2563 67.6876L50.0187 54.4376L36.6875 67.7811C35.4562 68.9998 33.4626 68.9998 32.2313 67.7811C31.0032 66.5311 31.0032 64.5313 32.2313 63.3125L45.5626 49.9687L32.325 36.75C31.1031 35.5313 31.1031 33.5311 32.325 32.3124C33.5406 31.0936 35.5219 31.0936 36.7437 32.3124L49.9813 45.5624L63.4125 32.1251C64.6437 30.9063 66.6343 30.9063 67.8656 32.1251C69.0937 33.3751 69.0937 35.3436 67.8656 36.5936L54.4374 50.0313L67.6781 63.25ZM50 0C22.3844 0 0 22.375 0 50C0 77.625 22.3844 100 50 100C77.6156 100 100 77.625 100 50C100 22.375 77.6156 0 50 0Z"
                fill="#C7140E"
            />
        </svg>
    )
}
